import React from 'react'
import PropTypes from 'prop-types'
import { usePermissions } from '../contexts/permissions-context'
import Loading from './Loading'
import UnauthorizedPage from './UnauthorizedPage'

const LEVELS = {
  read: (a) => a.canRead,
  write: (a) => a.canWrite,
  superadmin: (a) => a.isSuperAdmin,
}

const NO_READ_MESSAGE =
  "Your role doesn't include ShortCircuit. Ask an administrator to turn ShortCircuit on for your role in Settings > App Roles."
const NO_WRITE_MESSAGE =
  'Your role can view ShortCircuit but not create or edit. Ask an administrator if you need to edit.'
const NO_ADMIN_MESSAGE = 'Only a super admin can open this page.'
const LOAD_FAILED_MESSAGE = "Your ShortCircuit access couldn't be checked. Try again in a moment."

/**
 * Renders children only when the user's app role allows `level` in
 * ShortCircuit (core/access.js), else an access-denied page. The API refuses
 * the same requests, so this is about not showing pages that cannot work.
 */
const RequireAccess = ({ level = 'read', children }) => {
  const access = usePermissions()
  if (access.status === 'loading') return <Loading />
  if (LEVELS[level](access)) return children
  if (access.status === 'error') {
    return <UnauthorizedPage message={LOAD_FAILED_MESSAGE} showHome={false} onRetry={access.reload} />
  }
  if (!access.canRead) return <UnauthorizedPage message={NO_READ_MESSAGE} showHome={false} />
  return <UnauthorizedPage message={level === 'superadmin' ? NO_ADMIN_MESSAGE : NO_WRITE_MESSAGE} />
}

RequireAccess.propTypes = {
  level: PropTypes.oneOf(Object.keys(LEVELS)),
  children: PropTypes.node.isRequired,
}

export default RequireAccess
